import { useDialogStore } from '../store/dialog.store';

export function useDialogControls() {
  const isOpen = useDialogStore((state) => state.isOpen);
  const closeDialog = useDialogStore((state) => state.closeDialog);
  const submitDialog = useDialogStore((state) => state.submitDialog);

  return {
    open: isOpen,
    closeDialog,
    submitDialog,
  };
}
